<button class="btn btn-circle btn-primary" (click)="buttonClicked()">
  <smallstack-icon
    [name]="data().icon"
    size="24"
    [theme]="data().iconTheme"
    [color]="data().iconColor"
  ></smallstack-icon>
</button>
<div class="padder"></div>
